<template>
<div class="chapter">
<div class="inner_page">
<p style="text-align:center; margin-top:3pc"></p>
<p class="blockquote"><i>I think the Cherokee approach to life is being able</i></p>
<p class="blockquote"><i>to continually move forward with kind of a good mind</i></p>
<p class="blockquote"><i>and not focus on the negative things in your life</i></p>
<p class="blockquote"><i>and the negative things you see around you</i>,</p>
<p class="blockquote"><i>but focus on the positive things and try to look</i></p>
<p class="blockquote"><i>at the larger picture and keep moving forward.</i></p>
<p style="text-align:center; margin-top:.5pc"></p>
<p class="blockquote">—Wilma Mankiller, the first woman chief of the Cherokee Nation</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_epigraph.vue?65d737e8